// import NoteStore from '../stores/NoteStore.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';

import Header from './Header.js';
import NoteButton from './NoteButton.js';
import ModifierButton from './ModifierButton.js';
import ScaleImage from './ScaleImage.js';

// const images = require.context('../../public/images', true);

function PageNote() {
  useStores([SessionStore]);

  // const imageFileName = NoteStore.getCurrentImage();
  // const image = images(`./${imageFileName}`);
  const practice = SessionStore.getPractice();

  return (
    <>
      <Header />

      <ScaleImage />

      <div className="bottom" style={{zIndex: 1}}>
        {
          practice === 'name' &&
          <div class="buttons">
            <ModifierButton modifier="natural" />
            <ModifierButton modifier="sharp" />
            <ModifierButton modifier="flat" />

            <NoteButton note="A" />
            <NoteButton note="B" />
            <NoteButton note="C" />
            <NoteButton note="D" />
            <NoteButton note="E" />
            <NoteButton note="F" />
            <NoteButton note="G" />
          </div>
        }
        {
          practice === 'position' &&
          <div class="buttons">
            <NoteButton note="0" />
            <NoteButton note="↓1" />
            <NoteButton note="1" />
            <NoteButton note="↓2" />
            <NoteButton note="2" />
            <NoteButton note="↑2" />
            <NoteButton note="3" />
            <NoteButton note="3³" />
            <NoteButton note="4" />
            <NoteButton note="4³" />
            <br/>
            ↓=low, ↑=high, 3³ and 4³ are third position
          </div>
        }
      </div>
    </>
  );
}

export default PageNote;
